const truncate = (text: string, maxLen: number) => {
  if (!text) return ''
  if (text.length < maxLen) return text
  return `${text.substr(0, maxLen - 3)}...`
}

export { truncate }
